import { render, staticRenderFns } from "./denounced-modal.vue?vue&type=template&id=cfc8fe0e&scoped=true&"
import script from "./denounced-modal.vue?vue&type=script&lang=js&"
export * from "./denounced-modal.vue?vue&type=script&lang=js&"
import style0 from "./denounced-modal.vue?vue&type=style&index=0&id=cfc8fe0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc8fe0e",
  null
  
)

export default component.exports